<template>
  <el-dialog width="1000px" :visible='visible' :close-on-click-modal='false' :close-on-press-escape='false' @open = "open" append-to-body :modal="false" top="10vh"
    :show-close='false' @close='close' id="voucherDocument">
    <template #title>
      <div class="mk-dialog-title">{{ voucher.certificateWord + '-' +  voucher.selfNumber}}附单据</div>
    </template>
   <div class="document_content">
     <div class="document_content__title">
      <span class="title_left">发票</span>
      <el-button type="text" icon="el-icon-plus"  style="color:#269D7B;font-weight: 600;" @click = "handleJump('pageInvoice')">新增</el-button>
     </div>
     <!-- content -->
     <div class="content_wrapper">
        <div v-for = "i in invoice" :key = "i.fkBillId" class="content_item" :style = "{ color: i.isdel?'#999':'#333' }" @click = "handleJump('pageInvoice',i.fkBillId,i)">
            <div class="content_item__top">
              <span :style = "{ textDecoration: i.isdel?'line-through':'none' }">{{ i.dateStr || '2023-07-07' }}</span>
              <span style="margin-left: 10px;" :style = "{ textDecoration: i.isdel?'line-through':'none' }">{{ i.money }}</span>
            </div>
            <div :style = "{ textDecoration: i.isdel?'line-through':'none' }">{{ i.displayContent || "-" }}</div>
            <!-- close -->
            <i class="el-icon-error content_item__close" @click.stop="handleClose(i,true)" v-show="!i.isdel"></i>
            <i class="content_item__back el-icon-refresh-right" v-show="i.isdel" @click.stop="handleClose(i,false)"></i>
        </div>
        <div v-show = "!invoice.length" class="no_contact">
          暂无关联
        </div>
     </div>
   </div>
   <div class="document_content" style="margin-top: 20px;">
     <div class="document_content__title">
      <span class="title_left">银行</span>
      <el-button type="text" icon="el-icon-plus"  style="color:#269D7B;font-weight: 600;" @click = "handleJump('bank_running_water')">新增</el-button>
     </div>
     <!-- content -->
     <div class="content_wrapper">
      <div v-for = "i in bankStatement" :key = "i.fkBillId" class="content_item" :style = "{ color: i.isdel?'#999':'#333' }" @click = "handleJump('bank_running_water',i.fkBillId,i)">
            <div class="content_item__top">
              <span :style = "{ textDecoration: i.isdel?'line-through':'none' }">{{ i.dateStr || '2023-07-07' }}</span>
              <span :style = "{ textDecoration: i.isdel?'line-through':'none' }" style="margin-left: 10px;">{{ i.money }}</span>
            </div>
            <div :style = "{ textDecoration: i.isdel?'line-through':'none' }">{{ i.displayContent || "-" }}</div>
            <!-- close -->
            <i class="el-icon-error content_item__close" @click.stop="handleClose(i,true)" v-show="!i.isdel"></i>
            <i class="content_item__back el-icon-refresh-right" v-show="i.isdel" @click.stop="handleClose(i,false)"></i>
        </div>
      <div v-show = "!bankStatement.length" class="no_contact">
          暂无关联
        </div>
     </div>
   </div>
    <template #footer>
      <div style="text-align:center">
        <el-button @click="close" size="small" style="width:100px;">取消</el-button>
        <el-button @click="validInfo" size="small" style="width:100px;background:#269D7B;color:#fff">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { findVoucherBillInfo, updateVoucherBillInfo } from "@/api"
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    voucher: {
      type: Object,
      default: ()=> {}
    },
  },
  components: {
  },
  data() {
    return {
      bankStatement:[], // 银行
      invoice:[],  // 发票
    }
  },
  methods: {
    // 删除关联
    handleClose(row,status) {
      row.isdel = status;
    },
    // 获取凭证详情
    async getVoucherBillInfo() {
      let key = true
      if(!this.voucher.id) {
        this.$message.error("未检测到凭证id")
        return false
      }
      const { data } = await findVoucherBillInfo({ voucherChiefId: this.voucher.id });
      const info = data.data
      if(info) {
        let bankStatement = info.bankStatement || [];
        let invoice = info.invoice || [];
        if(!info.bankStatement.length && !info.invoice.length){
          key = false
        }
        bankStatement = bankStatement.map(i=> {
          return {
            ...i,
            isdel: false
          }
        })
        invoice = invoice.map(i=> {
          return {
            ...i,
            isdel: false
          }
        })
        this.bankStatement = bankStatement;
        this.invoice = invoice;
      }
      return key
    },
    open() {
      this.getVoucherBillInfo()
    },
    close() {
      this.$emit('close')
    },
    // 跳转页面
    handleJump(path,fkBillId,i) {
      // 如果是在本页面，则直接关闭当前弹框
      const nowPath = this.$route.path;
      if(nowPath !== ('/' + path)) {
        this.$router.push({ path: './' + path, query: { fkBillId,invoiceClassify:i?i.invoiceClassify||1:1 } })
      }
      this.$emit('closeAll')

    },
    // 保存信息
    async validInfo() {
      if(!this.voucher.id) {
        this.$message.error("未检测到凭证id")
        return
      }
      let invoice = this.invoice.filter(i=> !i.isdel)
      let bankStatement = this.bankStatement.filter(i=> !i.isdel)
      const num = invoice.length + bankStatement.length;
      const { data } = await updateVoucherBillInfo({ invoice, bankStatement, voucherChiefId: this.voucher.id })
      if(data.code == 1) {
        this.close();
        // 告诉外面现在还剩余的数量 num
        this.$emit("changeNum",num)
      }
    }
  }

}
</script>
<style lang="less" >
  #voucherDocument {
    right: 240px !important;
    overflow: hidden !important;
  }
</style>
<style lang='less' scoped>
.document_content {
  .content_wrapper {
    background: #FBFCFD;
    border-radius: 4px;
    height: 226px;
    overflow: auto;
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    .no_contact {
      color: #999;
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      line-height: 180px;
      width: 100%;
    }
    .content_item {
      padding: 10px;
      background: #FFFFFF;
      box-shadow: 0 2px 8px 0 #dbdbdb80;
      border-radius: 4px;
      margin-left: 10px;
      margin-bottom: 10px;
      border: 1px solid #fff;
      cursor: pointer;
      position: relative;
      &:hover {
        background: #F5FFFC;
        box-shadow: 0 2px 8px 0 #dbdbdb80;
        .content_item__close {
          display: block;
        }
      }
      &__back {
        position: absolute;
        right: -8px;
        top: -8px;
        font-size: 18px;
        z-index: 10;
        font-weight: 600;
        color: red;
      }
      &__close {
        position: absolute;
        right: -8px;
        top: -8px;
        font-size: 18px;
        z-index: 10;
        color: red;
        display: none;
      }
      &__top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 5px;
      }
    }
  }
  &__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title_left {
      color: #333333;
      font-weight: 600;
      font-size: 18px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/common/voucher-document.vue